import { IBaseQueryParameters } from '../index.js'

/**
 * This interface defines the path parameters for the endpoints available in the
 * `Nomination` endpoint class.
 */
export interface INominationPathParameters extends IBaseQueryParameters {
  /**
   * The congress number. For example, the value can be `117` for the 117th
   * Congress.
   */
  congress?: number

  /**
   * The nomination assigned number. For example, this value can be `3324`.
   */
  nominationNumber?: number

  /** The ordinal number. For example, the value can be `1`. */
  ordinal?: number
}
